export default {
  baseStyle: {
    color: 'primary.400',
  },
  sizes: {
    sm: 'small',
    lg: 'large',
  },
  defaultProps: {
    size: 'large',
  },
};
